import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { GlobalUtilService } from '@otas/core/services/global-util.service';

@Component({
    selector: 'app-choose-folder',
    template: `<div class="input-group">
  <input type="text" class="form-control" disabled="true" [(ngModel)]="selected">
  <span class="input-group-btn">
    <i class="fa" [ngClass]="{'fa-plus-circle': isMultiple,'fa-folder-open':!isMultiple}" 
    style="{{!!isMultiple?'font-size:24px;':''}}" aria-hidden="true" (click)="setFolder()"></i>
  </span>
</div>`,
    standalone: false
})
export class ChooseFolderComponent implements OnInit {
  @Input() selected = 'Choose Path ...';
  @Output() change = new EventEmitter<any>();
  @Input() isMultiple = false;

  constructor(private globalUtilService: GlobalUtilService) { }

  ngOnInit(): void {
  }
  setFolder() {
    const data = this.globalUtilService.IPCRendererSendSync('setPath');
    this.selected = data || this.selected;
    this.change.emit(this.selected)
    this.selected = this.isMultiple ? 'Choose Path ...' : (data || this.selected || 'Choose Path ...');
  }
}
